<template>
  <div class="card">
    <div style="overflow-y:scroll" class="card-body">
      <div class="card-head">
        <div class="card-title">{{ nameToShow }}</div>
        <b-navbar-nav class="ml-auto p-0 m-0 mt--3">
          <b-nav-item-dropdown
            toggle-class="text-dark"
            right
            no-caret
            class="p-0"
          >
            <!-- Using 'button-content' slot -->
            <template class="p-0 m-0" v-slot:button-content>
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item v-on:click="changeView('spotlight')" href="#"
              >SpotLight</b-dropdown-item
            >
            <b-dropdown-item v-on:click="changeView('settings')" href="#"
              >Setting</b-dropdown-item
            >
            <b-dropdown-item v-on:click="changeView('splash')" href="#"
              >Splash</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </div>
      <slot v-if="view == 'spotlight'" />
      <div v-if="view == 'splash'" class="splash-view">
        <h4>{{ cardname }}</h4>
      </div>
      <div v-if="view == 'settings'" class="settings">
        <b-tabs content-class="mt-3">
          <b-tab title="Setting" active
            ><p>My Crew may access my set-up</p></b-tab
          >
          <b-tab title="Setup"><p>Nothing to setup</p></b-tab>
          <b-tab title="Connect"><p>Connect your devices!</p></b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardStructure",
  data() {
    return {
      view: "spotlight"
    };
  },
  props: {
    cardname: {
      type: String
    },
    bodyClass: String,
    headClass: String
  },
  computed: {
    nameToShow() {
      if (this.view == "spotlight") return this.cardname;
      else if (this.view == "settings") return "Settings";
      else return "";
    }
  },
  methods: {
    toggleDropdown(event) {
      event.currentTarget.classList.toggle("is-active");
    },
    changeView(view) {
      this.view = view;
      this.$emit("change-view", view);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  &__header {
    cursor: pointer;
    line-height: 50px;
    padding-left: 10px;
    padding-right: 50px;
    position: relative;
    text-overflow: ellipsis;
    i.fa {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      transition: opacity 0.3s;
      &.fa-angle-up {
        opacity: 0;
      }
    }
    &.is-active {
      i.fa {
        &.fa-angle-up {
          opacity: 1;
        }
        &.fa-angle-down {
          opacity: 0;
        }
      }
      + .dropdown__content {
        height: auto;
        opacity: 1;
        visibility: visible;
      }
    }
  }
  &__content {
    height: 0;
    opacity: 0;
    overflow: hidden;
    padding: 15px 10px;
    transition: opacity 0.3s;
    visibility: hidden;
  }
}
.splash-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -42px;
}
</style>
<style>
.settings .nav {
  font-size: 10px;
  justify-content: space-between;
  flex-wrap: nowrap;
}
</style>
